import type { ModuleKey } from '@pmai/contracts';
import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { BizcyclePage } from '../features/bizcycle/bizcycle-page';
import { CustomerDetailPage } from '../features/customers/customer-detail-page';
import { CustomersPage } from '../features/customers/customers-page';
import { DashboardPage } from '../features/projects/dashboard-page';
import { ProjectPage } from '../features/projects/project-page';
import { ProjectsIndexPage } from '../features/projects/projects-index';
import { ReconciliationPage } from '../features/reconciliation/reconciliation-page';
import { ResourcesPage } from '../features/resources/resources-page';
import { SupportPage } from '../features/support/support-page';
import { TasksPage } from '../features/tasks/tasks-page';
import { TechnologiesPage } from '../features/technologies/technologies-page';
import { TurnoverPage } from '../features/turnover/turnover-page';
import { OverviewPage } from '../features/overview/overview-page';
import { RoadmapPage } from '../features/overview/roadmap-page';
import { TimeOverviewPage } from '../features/overview/time-overview-page';
import { JiraSettingsPage } from '../features/integrations/jira-settings-page';
import { ApiTokensPage } from '../features/workspace/api-tokens-page';
import { MembersPage } from '../features/workspace/members-page';
import { SessionsPage } from '../features/workspace/sessions-page';

/**
 * Registry key → page component (engineering.md §3: metadata in `@pmai/contracts` modules,
 * component binding here). A page module without an entry renders the "planned" page; a module
 * may only leave `planned` together with its page here (check C7).
 */
export const PAGES: Partial<Record<ModuleKey, ComponentType>> = {
  dashboard: DashboardPage,
  projects: ProjectsIndexPage,
  customers: CustomersPage,
  workspace: MembersPage,
  sessions: SessionsPage,
  'api-tokens': ApiTokensPage,
  resources: ResourcesPage,
  technologies: TechnologiesPage,
  tasks: TasksPage,
  turnover: TurnoverPage,
  support: SupportPage,
  overview: OverviewPage,
  roadmap: RoadmapPage,
  'jira-settings': JiraSettingsPage,
  reconciliation: ReconciliationPage,
  'time-overview': TimeOverviewPage,
  'business-cycle': BizcyclePage,
};

/** Sub-pages of a module (cards), relative to the module path. */
export const SUB_PAGES: Partial<
  Record<
    ModuleKey,
    readonly (Omit<RouteObject, 'element' | 'children' | 'index'> & {
      path: string;
      Component: ComponentType;
    })[]
  >
> = {
  customers: [{ path: ':id', Component: CustomerDetailPage }],
  projects: [{ path: ':id', Component: ProjectPage }],
};
